import React from 'react';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import TableAdv from '../../components/TableAdv';
import TableSimple from '../../components/TableSimple';
import Paper from '@material-ui/core/Paper/Paper';
import PieHollow from '../../components/PieHollow';
import { IconPrint } from '../../Icons';
import Rupee from '../../components/Rupee';
import _Helper from '../../_Helper';
// import { IconButton, Tooltip } from '@material-ui/core';
// import NewPersonMd from './NewPersonMd';
import HttpClient from '../../myapi';
import Store from '../../redux/store/index';
import { bkupPersons } from '../../redux/actions';
import PrintTitle from '../../components/PrintTitle';
import IconButton from '@material-ui/core/IconButton/IconButton';

const styles = {
    root: {
        flex: 1,
        flexGrow: 1,
    },
    table2wrapper: {
        height: '73vh',
        marginTop: 16,
    },
    '@media print': {
        table2wrapper: {
            height: 'auto'
        },
        noShadow: {
            boxShadow: 'none',
        },
        printHidden: {
            display: 'none'
        },
    }
};
const header = [
    { label: 'Name of Person', key: 'name', type: 1 },
    { label: 'Installment', key: 'install', type: 2 },
    { label: 'City', key: 'city', type: 1 },
];
const header2 = [
    { label: 'Due Date', key: 'dt' },
    { label: 'Amount', key: 'amt' },
];
class ViewPerson extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            persons: [],
            selectedPerson: { paid: 0, totalPay: 0 },
            selectedTrans: [], //transactions of selected person
            newPersonModal: false,
            processingPay: false,
            payModalOpen: false
        };
    }

    componentDidMount() {
        this.getPersons();
    }

    getPersons = () => {
        HttpClient.get('/Persons/getInvestors').then(res => {
            this.setState({
                persons: res,
            });
            //BKUP IN STORE
            Store.dispatch(bkupPersons(res));
        });
    };

    personSelected = id => {
        const person = _Helper.searchRecord(this.state.persons, 'uid', id);
        
        this.setState({
            selectedPerson: person,
        });
        //GET TRANSACTIONS
        HttpClient.post('/Payment/getTransInvest', { uid: person.uid }).then(
            res => {
                person.paid = res.length * person.install;
                person.paidInstall = res.length;
                this.setState({
                    selectedTrans: res,
                    selectedPerson: person
                });
            }
        );
    };

    showPayModal = id => {
        if (this.state.processingPay) {
            alert('wait');
            return;
        }
        this.setState({ processingPay: true });

        const { persons } = this.state;
        const person = _Helper.searchRecordIndex(persons, 'uid', id);
        console.log('show modal ', person);
        
        // HttpClient.post('/Payment/saveInstallment', {
        //     uid: id,
        //     amt: person.row.install,
        // }).then(res => {
        //     if (res === '*') {
        //         persons[person.index].currPaid = 1;
        //         this.setState({
        //             persons: persons,
        //         });
        //     }
        //     this.setState({ processingPay: false });
        // });
    };

    editPerson = id => {
        console.log('editperson '+id);
    }

    printDiv = () =>{
        window.print();
    }

    render() {
        const { classes } = this.props;
        const { selectedTrans } = this.state;
        // const action1 = 
        // {
        //     action: this.markPaid,
        //     labelDefault: 'Pay',
        //     labelDone: 'Paid',
        // };

        return (
            <Grid xs={12} sm={12} md={12} lg={10} item>
                <Grid container>
                    <Grid style={{ height: '90vh' }} md={7} xs={12} item>
                        <TableAdv
                            data={this.state.persons}
                            header={header}
                            onSelect={this.personSelected}
                            action1={this.showPayModal}
                            action2={this.editPerson}
                            paginate={true}
                        />
                    </Grid>
                    <Grid id="print-content" style={{ paddingLeft: 20 }} md={5} xs={12} item>
                        <PrintTitle title="Money Transactions"/>
                        <PersonDetail info={this.state.selectedPerson} />

                        <Paper className={`${classes.table2wrapper} ${classes.noShadow}`}>
                            <Grid className={classes.printHidden} justify="space-between" container>
                                <Grid item>
                                    <Typography style={{padding: 6}} variant="subtitle1">
                                        Transactions
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <IconButton
                                        style={{ padding: 9 }}
                                        color="primary"
                                        onClick={this.printDiv}
                                    >
                                        <IconPrint style={{ fontSize: 20 }} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                            {selectedTrans.length ? (
                                <TableSimple
                                    data={selectedTrans}
                                    header={header2}
                                    caption="Transactions"
                                />
                            ) : (
                                <Grid justify="center" container>
                                    <Typography variant="h6" color="secondary">No Transactions !</Typography>
                                </Grid>
                            )}
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}
export default withStyles(styles)(ViewPerson);

const styles2 = {
    pieGrid: {
        height: 100,
        width: 100,
    },
    uinfo: {
        backgroundColor: '#aaa',
    },
    green: {
        color: '#009933',
    },
    '@media print': {
        noShadow: {
            boxShadow: 'none',
            border: '1px solid #ddd',
            width: '99%'
        },
    },
};

const PersonDetail = withStyles(styles2)(({ info, classes }) => (
    <Paper className={classes.noShadow}>
        <Grid container style={{ padding: 0 }} direction="row">
            <Grid className={classes.pieGrid} item>
                <PieHollow val1={info.paid} val2={info.totPay} />
            </Grid>
            <Grid style={{ flexGrow: 1 }} item>
                <Typography variant="subtitle1">{info.name}&nbsp;</Typography>
                <Grid justify="space-between" container>
                    <Grid item>
                        <Grid direction="column" alignContent="center" container>
                            <Grid item>
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                >
                                {/* <IconPlace style={{ fontSize: 16 }} />  */}
                                City: {info.city}
                                </Typography>
                                </Grid>
                                <Grid item>
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Acct No: {info.acct}
                                </Typography>
                                </Grid>
                                <Grid item>
                                <Typography
                                    variant="caption"
                                    color="textSecondary"
                                >
                                    Bank: {info.bank} ({info.branch})
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid
                            direction="column"
                            style={{ paddingRight: 12 }}
                            alignItems="flex-end"
                            container
                        >
                            <Grid item>
                                <Typography variant="caption" color="primary">
                                    Installation Paid: { info.paidInstall }
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="caption" color="secondary">
                                    Amount Paid: <Rupee amount={info.paid} />
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Typography
                                    variant="caption"
                                    className={classes.green}
                                >
                                    Amount Collected:{' '}
                                    <Rupee amount={info.totPay} />
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    </Paper>
));

// const padding6 = {
//     padding: 6,
//     margin: '1px 0',
// };
// const Toolbar = ({ action1 }) => (
//     <Grid container style={{ flexGrow: 1 }}>
//         <Grid item>
//             <Tooltip title="Add New Pin">
//                 <IconButton color="primary" style={padding6} onClick={action1}>
//                     <IconPersonAdd />
//                 </IconButton>
//             </Tooltip>
//         </Grid>
//         <Grid item />
//     </Grid>
// );
